import React, {Component} from "react";
class Visualizer extends Component {
    constructor(props) {
        super(props);
        this.barsInterval = null;
        this.setBarsRef = this.setBarsRef.bind(this);
        this.running = this.running.bind(this);
    }

    setBarsRef(ref) {
        this.barsContainer = ref;
    }

    componentDidMount() {
        if (!this.barsContainer) return;

        this.bars = this.barsContainer.querySelectorAll('span');
        this.barsInterval = setInterval(this.running, 200);
    }

    componentWillUnmount() {
        if (this.barsInterval) {
            clearInterval(this.barsInterval);
            this.barsInterval = null;
        }
        this.bars = null;
    }

    running() {
        if (this.bars) {
            Array.prototype.forEach.call(this.bars, bar => {
                const height = Math.floor(Math.random() * 16) + 5;
                bar.style.height = `${height}px`;
            });
        }
    }

    render() {
        return (
            <div className="eq" ref={this.setBarsRef}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        );
    }
}

export default Visualizer;


// WEBPACK FOOTER //
// ./src/pages/components/elements/visualizer.jsx